import {Component} from "@angular/core";

@Component({
    selector: "fui-buttons",
    styleUrls: ["./buttons.component.scss"],
    templateUrl: "./buttons.component.html",
    standalone: false
})
export class FUIButtonsComponent {
    constructor() {

    }
}
